var insertResults = require('./insert-results');

module.exports = function (apiEndpoint) {
    var $page = $('#landing-page-with-search');

    if (!$page.length) {
        return;
    }

    $page.find('.dropdown-filters-info__item-close').click(function (e) {
        e.preventDefault();

        var $tagClose = $(this);
        var $tag = $tagClose.closest('.dropdown-filters-info__item');

        var type = $tag.data('type');
        var val = $tag.data('value');

        if (type === 'region') {
            var index = window.regions.indexOf(val);
            if (index > -1) {
                window.regions.splice(index, 1);

                var regionFilters;

                if(window.ICF.Utils.Breakpoints.IsAtLeastDesktopSm()) {
                    if (window.$topicContentDesktopContent) {
                       regionFilters = window.$regionContentDesktopContent;
                    }
                }
                else {
                    if ($('#RegionFilteringModal').length) {
                        regionFilters = $('#RegionFilteringModal');
                    }
                    else if ($('#person-index__region-dropdown__touch-content').length){
                        regionFilters = $('#person-index__region-dropdown__touch-content');
                    }
                }

                if (regionFilters) {
                    regionFilters.find('input[value="' + val + '"]').attr('checked', false);

                    var $checkboxes = regionFilters.find('input[type="checkbox"]');
                    var isAnyChecked = false;

                    $checkboxes.each(function () {
                        if ($(this).is(':checked')) {
                            isAnyChecked = true;
                        }
                    });

                    if (!isAnyChecked) {
                        regionFilters.find('.popover__cta--reset').addClass('popover__cta--hidden');
                        $('.dropdown-filter--region').removeClass('dropdown-filter--active');
                    }
                }
            }
        }
        else if (type === 'topic') {
            var index = window.topics.indexOf(val);
            if (index > -1) {
                window.topics.splice(index, 1);

                var topicFilters;
                
                if(window.ICF.Utils.Breakpoints.IsAtLeastDesktopSm()) {
                    if (window.$topicContentDesktopContent) {
                      topicFilters = window.$topicContentDesktopContent;
                  }
                }
                else {
                    if ($('#TopicFilteringModal')) {
                      topicFilters = $('#TopicFilteringModal');
                  }   
                }

                topicFilters.find('input[value="' + val + '"]').attr('checked', false);

                var $checkboxes = topicFilters.find('input[type="checkbox"]');
                var isAnyChecked = false;

                $checkboxes.each(function () {
                    if ($(this).is(':checked')) {
                        isAnyChecked = true;
                    }
                });

                if (!isAnyChecked) {
                    topicFilters.find('.popover__cta--reset').addClass('popover__cta--hidden');
                    $('.dropdown-filter--topic').removeClass('dropdown-filter--active');
                }
            }
        }
        else if (type === 'contentLabel') {
            var index = window.contentLabels.indexOf(val);
            if (index > -1) {
                window.contentLabels.splice(index, 1);

                var contentFilters;
                
                if(window.ICF.Utils.Breakpoints.IsAtLeastDesktopSm()) {
                    if (window.$contentLabelContentDesktopContent) {
                      contentFilters = window.$contentLabelContentDesktopContent;
                  }
                }
                else {
                    if ($('#ContentLabelFilteringModal')) {
                      contentFilters = $('#ContentLabelFilteringModal');
                  }   
                }

                if (contentFilters) {
                    contentFilters.find('input[value="' + val + '"]').attr('checked', false);

                    var $checkboxes = contentFilters.find('input[type="checkbox"]');
                    var isAnyChecked = false;

                    $checkboxes.each(function () {
                        if ($(this).is(':checked')) {
                            isAnyChecked = true;
                        }
                    });

                    if (!isAnyChecked) {
                        contentFilters.find('.popover__cta--reset').addClass('popover__cta--hidden');
                        $('.dropdown-filter--content-label').removeClass('dropdown-filter--active');
                    }
                }
            }
        }

        if (window.regions && !window.regions.length && window.topics && !window.topics.length && window.contentLabels && !window.contentLabels.length) {
            $('.dropdown-filters').removeClass('dropdown-filters--active');
        }

        window.page = 1;
        window.topicMatchType = '';

        insertResults(apiEndpoint);
    });
};